import React from 'react';

const Loader =() => {
    return <div className="loader">Loading....</div>
}
export default Loader;